$(window).on("load", function() {
window.setTimeout(function(){
    $(".inview-fadein").addClass('FadeIn');
}, 200);
});

$(window).on("load resize orientationchange", function(){
    var w = $(window).width();
    var x = 1024;
    if (w <= x) { $(window).scroll(function() {
          if ($(this).scrollTop() > 400) {
                 $('.inview-fadein').removeClass( 'FadeIn' );
            } else {
               $('.inview-fadein').addClass( 'FadeIn' );
            }
        });
    } else { //1081px以上
        //スクロールが30に達したら表示
        $(window).scroll(function() {
          if ($(this).scrollTop() > 400) {
                 $('.inview-fadein').removeClass( 'FadeIn' );
            } else {
               $('.inview-fadein').addClass( 'FadeIn' );
            }
        });
    }
});